// Funkcja pomocnicza do usuwania pozycji z sitemap
function removeSitemapItem(
    sitemapBuilder: SitemapBuilder,
    name: string
): SitemapBuilder
{
    const currentNodes = (sitemapBuilder as any).sitemap;

    if (currentNodes && Array.isArray(currentNodes))
    {
        const index = currentNodes.findIndex((p: any) => p.name === name);

        if (index !== -1)
        {
            currentNodes.splice(index, 1);
        }
    }

    return sitemapBuilder;
}

export default (sitemap: SitemapBuilder) =>
{
    removeSitemapItem(
        sitemap.find('[[[System]]]', '[[[Administracja]]]'),
        '[[[Zastępstwa]]]'
    );
    removeSitemapItem(
        sitemap.find('[[[System]]]', '[[[Ustawienia]]]'),
        '[[[Oferty pracy - Import]]]'
    );
    removeSitemapItem(
        sitemap.find('[[[System]]]', '[[[Ustawienia]]]'),
        '[[[Aktywacja kont po rejestracji]]]'
    );
    removeSitemapItem(sitemap.find('[[[System]]]'), '[[[Asystent AI]]]');
    removeSitemapItem(sitemap.find('[[[Moduły]]]'), '[[[Rotatory opinii]]]');
    removeSitemapItem(sitemap.find('[[[Moduły]]]'), '[[[Gazetka]]]');
    removeSitemapItem(sitemap.find('[[[Moduły]]]'), '[[[Baza PDF]]]');
    removeSitemapItem(sitemap.find('[[[Moduły]]]'), '[[[Forum]]]');
    removeSitemapItem(sitemap.find('[[[Moduły]]]'), '[[[Baza ogłoszeń]]]');
    removeSitemapItem(sitemap.find('[[[Moduły]]]'), '[[[Erecruiter]]]');
    removeSitemapItem(sitemap.find('[[[Moduły]]]'), '[[[Rezerwacja zasobów]]]');
    removeSitemapItem(
        sitemap.find('[[[Moduły]]]', '[[[Baza dokumentów]]]'),
        '[[[Ustawienia generowania streszczeń]]]'
    );
    removeSitemapItem(sitemap.find('[[[Marketing]]]'), '[[[Subskrypcje]]]');
    removeSitemapItem(sitemap.find('[[[Marketing]]]'), '[[[Komentarze]]]');
    removeSitemapItem(sitemap.find('[[[Marketing]]]'), '[[[Top tematy]]]');
    removeSitemapItem(
        sitemap.find('[[[Marketing]]]'),
        '[[[Linki wewnętrzne]]]'
    );
    removeSitemapItem(sitemap.find('[[[Marketing]]]'), '[[[Banery]]]');
    removeSitemapItem(sitemap.find('[[[Marketing]]]'), '[[[RSS]]]');
    removeSitemapItem(sitemap.find('[[[Marketing]]]'), '[[[Polubienia]]]');
    removeSitemapItem(sitemap, '[[[Narzędzia AI]]]');
    removeSitemapItem(
        sitemap.find('[[[E-learning]]]', '[[[Raporty]]]'),
        '[[[Chat z raportami szkoleń]]]'
    );
    removeSitemapItem(sitemap, '[[[Spotkania]]]');
};
